/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo {
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage>}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo
     */
    planImages?: Array<JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImage>;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planImages': !exists(json, 'planImages') ? undefined : ((json['planImages'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageFromJSON)),
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'planImages': value.planImages === undefined ? undefined : ((value.planImages as Array<any>).map(JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponsePlanBasicInfoPlanImageToJSON)),
    };
}

